<div class="row">
    <div class="col-md-12 pl-4">
<!-- <yt-fw-default-update-buttons (SaveItemClicked)="Save()" (CloseItemClicked)="Close()" (AddItemClicked)="AddItem()"></yt-fw-default-update-buttons> -->
<yt-fw-default-update-buttons #defaultUpdateButtons></yt-fw-default-update-buttons>

<!-- [disabled]="baseFormGroup.get('ID').value==-1 || baseFormGroup.dirty" -->

<div class="btn-group ml-1">
    <button class="btn btn-outline-primary" type="button" >
        <span class="fa fa-fw fa-print"></span>Štampaj dokument
    </button>

    <!-- [disabled]="baseFormGroup.get('ID').value==-1 || baseFormGroup.dirty" -->

    <button class="btn btn-outline-primary" type="button" >
        <span class="fa fa-fw fa-print"></span> Za knjigovođu
    </button>
</div>
</div>
</div>
<yt-dokument-update #baseUpdate></yt-dokument-update>